import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Paper, Typography, Avatar, Box } from "@mui/material";
import { pb } from "../services/pocketbase";

const UserProfile = () => {
  const { username } = useParams();
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const records = await pb.collection("users").getList(1, 1, {
          filter: `username = "${username}"`,
        });
        if (records.items.length > 0) {
          setUser(records.items[0]);
        }
      } catch (err) {
        setError("User not found");
      }
    };
    fetchUser();
  }, [username]);

  if (error) {
    return (
      <Container maxWidth="sm">
        <Typography color="error" sx={{ mt: 4 }}>
          {error}
        </Typography>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container maxWidth="sm">
        <Typography sx={{ mt: 4 }}>Loading...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Paper sx={{ p: 4, mt: 4 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar
            src={
              user.avatar
                ? `${pb.baseUrl}/api/files/users/${user.id}/${user.avatar}`
                : null
            }
            sx={{ width: 150, height: 150, mb: 2 }}
            imgProps={{
              crossOrigin: "anonymous",
              referrerPolicy: "no-referrer",
            }}
          />
          <Typography variant="h4">{user.username}</Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default UserProfile;
